import { BaseModel } from "./BaseModel";

export abstract class BaseFindResult
{

    public numberOfPages: number = 0;
    public pageSize: number = 0;
    public totalResults: number = 0;
    public data: BaseModel[] = [];

    public assignObjects(): void {
        return;
    }

}
